import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tamr-icon-checkbox-checked",
  "use": "tamr-icon-checkbox-checked-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"tamr-icon-checkbox-checked\"><path d=\"M31,0H1A1,1,0,0,0,0,1V31a1,1,0,0,0,1,1H31a1,1,0,0,0,1-1V1A1,1,0,0,0,31,0ZM30,30H2V2H30V30Z\" /><path d=\"M12.2,21.6a1,1,0,0,0,.7.4H13l0.7-.3,11-10a1,1,0,1,0-1.3-1.5L13.1,19.6,8.8,14.4a1,1,0,1,0-1.5,1.3Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol